module.exports = __webpack_public_path__ + "img/3.bfbfcca3.jpeg";